<template lang="pug">
#acoes-em-lote-renovabio
    .lista-laudo-renovabio__upload-lote__filtros
        section.lista-laudo-renovabio__upload-lote__filtros__filtros-tag
            .lista-laudo-renovabio__filtro-selecionado__titulo
                h2 {{ $t('laudos.renovabio.acoesEmLoteListaLaudosTexto') }}

        el-button.mr-3(
            style='font-weight: bold',
            type='text',
            icon='el-icon-download',
            @click='exportarLaudosSelecionados()'
        ) {{ $t('laudos.renovabio.acoesEmLoteExportarLaudos') }}

        el-button(
            v-if='usuarioLogado?.isAnalyst ? false : true',
            style='font-weight: bold',
            type='text',
            icon='el-icon-upload2',
            @click='$emit("abrirModalUploadLote")'
        ) {{ $t('laudos.renovabio.acoesEmLoteSolicitarLaudos') }}

        el-button(
            v-if='!usuarioLogado?.isAnalyst',
            type='primary',
            icon='el-icon-download',
            @click='exportarDados()'
        )
            a
                | {{ $t('laudos.exportarDados') }}

    section.lista-laudo-renovabio__selecionar-todos(
        v-if='laudosSelecionadosDownload.length > 0'
    )
        div
            span {{ textoSelecionarTodas }}
            a(v-if='!selecionouTodos', @click='selecionouTodos = true') {{ textoLimparTodosSelecionados }}
            a(v-else, @click='limparSelecao') {{ textoLimparTodosSelecionados }}
</template>
<script>
import LaudoService from '@/modules/laudos/services/LaudosService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import AuthService from '@/services/AuthService';
import { mapState, mapGetters } from 'vuex';
import { disconnect } from '@/utils/websocket';
import EventBus from '@/utils/eventBus';
import store from '@/store';

export default {
    name: 'AcoesEmLote',

    data() {
        return {
            selecionouTodos: false
        };
    },

    props: {
        laudosSelecionadosDownload: {
            type: Array,
            default: () => []
        },
        totalPaginaLaudosSelecionados: {
            type: Number,
            default: 0
        },
        totalGeralLaudosProcessados: {
            type: Number,
            default: 0
        },
        laudos: {
            type: Array,
            default: () => []
        },
        filtros: {
            type: Object,
            default: () => ({})
        },
        totalPaginas: {
            type: Number,
            default: 0
        },
        dataConsulta: null
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters([
            'emProcessamentoUploadLoteRenovabio',
            'emProcessamentoDownloadLoteRenovabio',
            'limparSelecaoLoteRenovabio'
        ]),

        textoSelecionarTodas() {
            if (
                this.laudosSelecionadosDownload.length > 0 &&
                !this.selecionouTodos
            ) {
                if (this.totalPaginaLaudosSelecionados === 1) {
                    return `${this.totalPaginaLaudosSelecionados} ${this.$t(
                        'laudos.renovabio.textoSelecionarTodas1'
                    )} `;
                } else if (
                    this.totalPaginaLaudosSelecionados ===
                    this.totalLaudosStatusProcessados
                ) {
                    return `${this.$t('laudos.renovabio.todos')} ${
                        this.totalPaginaLaudosSelecionados
                    } ${this.$t('laudos.renovabio.textoSelecionarTodas2')}  `;
                } else if (
                    this.totalPaginaLaudosSelecionados !==
                        this.totalLaudosStatusProcessados &&
                    this.totalPaginaLaudosSelecionados > 0
                ) {
                    return `${this.totalPaginaLaudosSelecionados} ${this.$t(
                        'laudos.renovabio.textoSelecionarTodas2'
                    )}  `;
                } else if (
                    this.totalPaginaLaudosSelecionados !==
                        this.totalLaudosStatusProcessados &&
                    this.totalPaginaLaudosSelecionados === 1
                ) {
                    return `${this.totalPaginaLaudosSelecionados} ${this.$t(
                        'laudos.renovabio.textoSelecionarTodas1'
                    )}  `;
                }
                return ``;
            } else if (
                this.laudosSelecionadosDownload.length > 0 &&
                this.selecionouTodos
            ) {
                return `${this.$t('laudos.renovabio.todos')} ${
                    this.totalGeralLaudosProcessados
                } ${this.$t('laudos.renovabio.textoSelecionarTodas3')}  `;
            } else {
                return '';
            }
        },
        textoLimparTodosSelecionados() {
            if (
                this.laudosSelecionadosDownload.length > 0 &&
                this.selecionouTodos &&
                this.totalPaginas > 1
            ) {
                return this.$t('laudos.renovabio.limparSelecao');
            } else if (
                this.totalPaginaLaudosSelecionados ===
                    this.totalLaudosStatusProcessados &&
                this.totalPaginas > 1
            ) {
                return `${this.$t('laudos.renovabio.selecionarTodos')} ${
                    this.totalGeralLaudosProcessados
                } ${this.$t('laudos.renovabio.textoSelecionarTodas4')}`;
            } else {
                return '';
            }
        },
        totalLaudosStatusProcessados() {
            return this.laudos.filter(
                item => item.situacao.nome === 'Processado'
            ).length;
        }
    },

    beforeDestroy() {
        if (
            !this.emProcessamentoUploadLoteRenovabio &&
            !this.emProcessamentoDownloadLoteRenovabio
        ) {
            disconnect();
        }
    },

    mounted() {
        EventBus.$off('laudos:resetar-selecionar-todos');
        EventBus.$on('laudos:resetar-selecionar-todos', () => {
            this.selecionouTodos = false;
        });
    },

    watch: {
        selecionouTodos(newValue) {
            if (newValue) {
                if (
                    this.totalPaginaLaudosSelecionados !==
                    this.totalLaudosStatusProcessados
                ) {
                    EventBus.$emit('laudos:marcar-todos');
                }
            }
        },

        limparSelecaoLoteRenovabio(newValue) {
            if (newValue === true) {
                this.limparSelecao();
                store.dispatch('setLimparSelecaoLoteRenovabio', false);
            }
        }
    },

    methods: {
        exportarDados() {
            LaudoService.exportXlsx(TipoLaudo.RENOVABIO)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('laudos.exportacaoRealizadaComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('laudos.erroAoRealizarExportacao')
                    });
                });
        },
        loopingTimeout() {
            this.timeoutEvitarLogOff = setInterval(() => {
                this.buscarDadosUsuarioLogado();
            }, 120000);
        },

        async buscarDadosUsuarioLogado() {
            await AuthService.buscarDadosUsuarioLogado(false);
        },

        limparSelecao() {
            this.$emit('limparSelecao');
            this.selecionouTodos = false;
        },

        async exportarLaudosSelecionados() {
            if (
                this.laudosSelecionadosDownload.filter(
                    item => item.situacao.nome === 'Processado'
                ).length > 0
            ) {
                if (
                    this.laudosSelecionadosDownload.length > 0 &&
                    !this.selecionouTodos &&
                    this.totalPaginas > 1
                ) {
                    let idsLaudos = this.laudosSelecionadosDownload.map(
                        item => item.id
                    );
                    try {
                        await LaudoService.processarDownloadParcialLaudosProcessadosRenovabios(
                            { idsLaudos },
                            idsLaudos.length
                        );
                        this.$notify.success({
                            message: this.$t(
                                'laudos.renovabio.successMessageDownloadParcial'
                            )
                        });
                        this.limparSelecao();
                    } catch (error) {
                        this.$notify.error({
                            message: this.$t(
                                'laudos.renovabio.errorMessageDownloadLote'
                            )
                        });
                    }
                } else if (
                    this.laudosSelecionadosDownload.length > 0 &&
                    this.selecionouTodos &&
                    this.totalPaginas > 1
                ) {
                    if (
                        this.emProcessamentoUploadLoteRenovabio ||
                        this.emProcessamentoDownloadLoteRenovabio
                    ) {
                        this.$notify.warning({
                            message: this.$t(
                                'laudos.renovabio.laudoEmLoteEmProcessamentoAsync'
                            )
                        });
                        return;
                    }

                    let laudosSelecionadosDownloadLoteRenovabio = {
                        idsLaudos: null,
                        filtros: {
                            ...this.filtros,
                            dataConsulta: this.dataConsulta
                        }
                    };

                    store.dispatch(
                        'setEmProcessamentoDownloadLoteRenovabio',
                        true
                    );
                    store.dispatch(
                        'setLaudosSelecionadosDownloadLoteRenovabio',
                        laudosSelecionadosDownloadLoteRenovabio
                    );
                } else if (
                    this.laudosSelecionadosDownload.length > 0 &&
                    !this.selecionouTodos &&
                    this.totalPaginas === 1
                ) {
                    if (
                        this.laudos.length ===
                        this.laudosSelecionadosDownload.length
                    ) {
                        if (
                            this.emProcessamentoUploadLoteRenovabio ||
                            this.emProcessamentoDownloadLoteRenovabio
                        ) {
                            this.$notify.warning({
                                message: this.$t(
                                    'laudos.renovabio.laudoEmLoteEmProcessamentoAsync'
                                )
                            });
                            return;
                        }

                        let laudosSelecionadosDownloadLoteRenovabio = {
                            idsLaudos: null,
                            filtros: this.filtros
                        };

                        store.dispatch(
                            'setEmProcessamentoDownloadLoteRenovabio',
                            true
                        );
                        store.dispatch(
                            'setLaudosSelecionadosDownloadLoteRenovabio',
                            laudosSelecionadosDownloadLoteRenovabio
                        );
                    } else if (
                        this.laudos.length !==
                        this.laudosSelecionadosDownload.length
                    ) {
                        let idsLaudos = this.laudosSelecionadosDownload.map(
                            item => item.id
                        );
                        try {
                            await LaudoService.processarDownloadParcialLaudosProcessadosRenovabios(
                                { idsLaudos },
                                idsLaudos.length
                            );
                            this.$notify.success({
                                message: this.$t(
                                    'laudos.renovabio.successMessageDownloadParcial'
                                )
                            });
                            this.limparSelecao();
                        } catch (error) {
                            this.$notify.error({
                                message: this.$t(
                                    'laudos.renovabio.errorMessageDownloadLote'
                                )
                            });
                        }
                    }
                }
            } else {
                this.$notify({
                    type: 'error',
                    dangerouslyUseHTMLString: true,
                    message: this.$t('laudos.renovabio.errorSelectLaudosLote')
                });
            }
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        formatDate(date) {
            return [
                this.padTo2Digits(date.getDate()),
                this.padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
        }
    }
};
</script>
<style lang="scss">
#acoes-em-lote-renovabio {
    .lista-laudo-renovabio__upload-lote__filtros {
        margin: 0 0px 5px 0px;
        min-height: 42px;
        max-height: 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .lista-laudo-renovabio__upload-lote__filtros__filtros-tag {
            width: calc(100% - 142px);
            overflow: auto;
            display: flex;
        }

        .lista-laudo-renovabio__filtro-selecionado__filtros-tag {
            overflow: auto;
            max-width: calc(100% - 300px);
            max-height: 42px;
        }

        .lista-laudo-renovabio__filtro-selecionado__tag {
            margin: 0 5px 5px 5px;
        }

        .lista-laudo-renovabio__filtro-selecionado__titulo {
            font-size: 16px;
            font-weight: 400;
            margin-right: 10px;
            width: 250px;
            display: flex;
            align-items: center;
        }

        .lista-laudo-renovabio__filtro-selecionado__limpar {
            cursor: pointer;
            margin: 0 5px 0 5px;

            i {
                padding-left: 5px;
            }
        }

        .lista-laudo-renovabio__filtro-selecionado__nenhum {
            margin-left: 5px;
            font-weight: 100;
            font-style: italic;
            font-size: 14px;
        }
    }

    .lista-laudo-renovabio__selecionar-todos {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0px 20px 0px;
        border-radius: 5px;
        height: 42px;
        background-color: #70ad474d;
        box-shadow: 0 1px 5px 0 var(--block-shadow);
        font-size: 14px;
        font-weight: 600;
        color: #3b3b3b;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;

        a {
            color: #2284dd;
            cursor: pointer;
            line-height: 16px;
            font-size: 14px;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

.el-loading-spinner .el-loading-text {
    max-width: 600px;
    position: absolute;
    right: 35%;
}
</style>
